import { createContext } from 'react'

const VerifyStatsContext = createContext()

export default VerifyStatsContext
